import { render } from "./Movie.vue?vue&type=template&id=f4560670&scoped=true"
import script from "./Movie.vue?vue&type=script&lang=js"
export * from "./Movie.vue?vue&type=script&lang=js"

import "./Movie.vue?vue&type=style&index=0&id=f4560670&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4560670"]])

export default __exports__